export default {
  /**
   * Make the specified school result the selected school.
   *
   * @param {Object} state The Vuex Store
   * @param {Object} school The search result from the school autocomplete as an object.
   * @example This is the indicative structure of a school autocomplete result:
   *
   * {
   *   site_email: "eastwood-p.school@det.nsw.edu.au"
   *   site_enrolments: "882.0"
   *   site_name: "Eastwood Public School"
   *   site_operational_directorate: "Metropolitan North"
   *   site_phone: "9874 1600"
   *   site_postcode: "2122"
   *   site_principal_name: "Davis, Helen"
   *   site_principal_network: "Carlingford"
   *   site_school_no: "7416"
   *   site_street: "Rowe St"
   *   site_suburb: "Eastwood"
   * }
   */
  setSchool: (state, school) => {
    if (!school) {
      console.error("Unexpected undefined value for school");
    }
    state.selected.site_email = school['site_email'];
    state.selected.site_enrolments = school['site_enrolments'];
    state.selected.site_name = school['site_name'];
    state.selected.site_operational_directorate = school['site_operational_directorate'];
    state.selected.site_phone = school['site_phone'];
    state.selected.site_postcode = school['site_postcode'];
    state.selected.site_principal_name = school['site_principal_name'];
    state.selected.site_principal_network = school['site_principal_network'];
    state.selected.site_code = school['site_code'];
    state.selected.site_street = school['site_street'];
    state.selected.site_suburb = school['site_suburb'];
    state.selected.site_id = school['site_id'];
    state.selected.site_parent_site = school['site_parent_site'];

    sessionStorage.setItem('ictp-selected-sitecode', school.site_code);
  },

  SCHOOL_REQUEST: (state) => {
    state.selected.loading = true;
    state.selected.error = null;
  },

  SCHOOL_SUCCESS: (state, {response}) => {
    state.selected.loading = false;
    state.selected.error = null;
    if (response.data && response.data.data) {
      const school = response.data.data;
      state.selected = school;
    }
  },

  SCHOOL_FAILURE: (state, err) => {
    state.selected.loading = false;
    state.selected.error = err;
  },

  SCHOOL_SEARCH_REQUEST: (state) => {
    state.results.loading = true;
  },

  SCHOOL_SEARCH_SUCCESS: (state, {response}) => {
    state.results.loading = false;
    state.results.error = null;
    if (response.data && response.data.data) {
      state.results.data = response.data.data;
    }
  },

  SCHOOL_SEARCH_FAILURE: (state, err) => {
    state.results.loading = false;
    state.results.error = err;
  },

  SCHOOL_CHILD_SCHOOLS_REQUEST: (state) => {
    state.childSchools = [];
  },

  SCHOOL_CHILD_SCHOOLS_SUCCESS: (state, {response}) => {
    if (response.data && response.data.data) {
      const childSchools = response.data.data;
      if (Array.isArray(childSchools) && childSchools.length > 0) {
        childSchools.sort((a,b) => (a.site_code > b.site_code) ? 1 : ((b.site_code > a.site_code) ? -1 : 0));
        state.childSchools = childSchools;
      }
    }
  },

  SCHOOL_CHILD_SCHOOLS_FAILURE: (state) => {
    state.childSchools = [];
  },
}

